import React from 'react';
import { Route } from "react-router-dom";
import AppLogout from '../../common/isLogout';
import { PrivateRoute } from '../../common/PrivateRoutes';
import ReferralManagement from '../../Pages/Referral';
import DashboardLayout from '../../Layouts/DashboardLayouts';

const ReferralRoutes = () => (
    <>
        {/* Referral ThreeWheeler */}
        <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
            <Route exact path="/3w/referral" element={<AppLogout><PrivateRoute><ReferralManagement /></PrivateRoute></AppLogout>} />
        </Route>

    </>
);

export default ReferralRoutes;